export const pl = {
  // Common
  "common.back": "Wstecz",
  "common.cancel": "Anuluj",
  "common.noItems": "Brak elementów",
  "common.loading": "Ładowanie...",
  
  // Header
  "nav.features": "Funkcje",
  "nav.howItWorks": "Jak to działa",
  "nav.pricing": "Cennik",
  "nav.faq": "FAQ",
  "nav.testimonials": "Galeria",
  "nav.contact": "Kontakt",
  "button.getStarted": "Rozpocznij",
  "button.loading": "Ładowanie...",

  // Auth related
  "auth.signIn": "Zaloguj się",
  "auth.redirecting": "Przekierowywanie...",
  "auth.continueWithGoogle": "Kontynuuj z Google",
  "auth.continueWithGithub": "Kontynuuj z GitHub",
  "auth.or": "LUB",
  "auth.consent.prefix": "Kontynuując, akceptujesz nasze",
  "auth.consent.terms": "Warunki",
  "auth.consent.and": "i",
  "auth.consent.privacy": "Polityka prywatności",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "Asystent Komunikacji AI",
  "hero.subtitle": "Przekształć swoje rozmowy dzięki inteligentnym, świadomym kontekstu odpowiedziom, które pomogą Ci komunikować się skuteczniej w każdej sytuacji.",
  "hero.cta.primary": "Bezpłatny okres próbny",
  "hero.cta.secondary": "Zobacz demo",
  "hero.cta.tryNow": "Rozpocznij za darmo",
  "hero.cta.learnMore": "Dowiedz się więcej",
  "hero.cta.getStarted": "Rozpocznij za darmo",
  "hero.preview.primary": "Popraw ton",
  "hero.preview.secondary": "Przetłumacz",
  "hero.preview.tone": "Przyjazny",
  "hero.preview.target": "Klient",
  "hero.hook": "Dołącz do tysięcy użytkowników, którzy codziennie doskonalą swoją komunikację.",
  "hero.headline": "Asystent Komunikacji AI",
  "hero.subheadline": "Przekształć surowe pomysły w dopracowane, kontekstowe odpowiedzi w kilka sekund.",
  
  // Stats
  "stats.users": "Użytkownicy",
  "stats.replies": "Odpowiedzi",
  "stats.languages": "Języki",

  // Main Title
  "main.title": "Zamień każdą odpowiedź w szansę",

  // Footer Section
  "footer.company": "Firma",
  "footer.product": "Produkt",
  "footer.support": "Wsparcie",
  "footer.legal": "Informacje prawne",
  "footer.contactSupport": "Skontaktuj się z pomocą techniczną",
  "footer.helpCenter": "Centrum pomocy",
  "footer.apiDocs": "Dokumentacja API",
  "footer.statusPage": "Strona statusu",
  "footer.privacyPolicy": "Polityka prywatności",
  "footer.termsOfService": "Warunki korzystania z usługi",
  "footer.cookiePolicy": "Polityka cookies",
  "footer.refundPolicy": "Polityka zwrotów",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "Wsparcie",

  // Features Section
  "features.badge": "Potężne funkcje",
  "features.title": "Wszystko czego potrzebujesz do lepszej komunikacji",
  "features.subtitle": "Kompleksowe narzędzia zaprojektowane, aby każda rozmowa była bardziej skuteczna i profesjonalna.",
  "features.scenario.title": "Szablony scenariuszy",
  "features.scenario.description": "Gotowe szablony do komunikacji w pracy, osobistej, akademickiej i profesjonalnej.",
  "features.custom.title": "Niestandardowe dane wejściowe",
  "features.custom.description": "Wklej dowolną wiadomość lub treść i otrzymaj kontekstowo odpowiednie odpowiedzi.",
  "features.instant.title": "Skróć czas odpowiedzi o 90%",
  "features.instant.description": "Otrzymuj odpowiedzi stworzone przez AI w ciągu kilku sekund. Bez czekania, tylko rezultaty.",
  "features.copy.title": "Kopiowanie i udostępnianie jednym kliknięciem",
  "features.copy.description": "Kopiuj odpowiedzi natychmiast lub udostępniaj je bezpośrednio z platformy.",

  // How It Works Section
  "howItWorks.badge": "Jak to działa",
  "howItWorks.title": "Trzy proste kroki do lepszej komunikacji",
  "howItWorks.subtitle": "Nasz usprawniony proces ułatwia generowanie profesjonalnych odpowiedzi w każdej sytuacji.",
  "howItWorks.step1.title": "Wybierz scenariusz",
  "howItWorks.step1.description": "Wybierz scenariusz komunikacji, który najlepiej odpowiada Twoim potrzebom.",
  "howItWorks.step2.title": "Wklej treść",
  "howItWorks.step2.description": "Dodaj wiadomość lub treść, na którą musisz odpowiedzieć.",
  "howItWorks.step3.title": "Otrzymaj odpowiedź AI",
  "howItWorks.step3.description": "Otrzymaj profesjonalną, kontekstową odpowiedź w ciągu sekund.",

  // Pricing Section
  "pricing.title": "Cennik",
  "pricing.subtitle": "Wybierz plan dopasowany do Twoich potrzeb komunikacyjnych",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/miesiąc",
  "pricing.free.description": "Idealny do wypróbowania naszej usługi",
  "pricing.pro.description": "Idealny dla profesjonalistów i częstych użytkowników",
  "pricing.business.description": "Dla zespołów i organizacji",
  "pricing.popular": "Najpopularniejszy",
  "pricing.free.feature1": "10 odpowiedzi miesięcznie",
  "pricing.free.feature2": "Podstawowy scenariusz",
  "pricing.free.feature3": "Definiuj i używaj szablonów",
  "pricing.free.feature4": "Historia odpowiedzi",
  "pricing.pro.feature1": "200 odpowiedzi miesięcznie",
  "pricing.pro.feature2": "Podstawowy+niestandardowy scenariusz",
  "pricing.pro.feature3": "Definiuj i używaj szablonów",
  "pricing.pro.feature4": "Historia odpowiedzi",
  "pricing.pro.feature5": "Zaawansowane dostosowanie",
  "pricing.business.feature1": "Nieograniczone odpowiedzi",
  "pricing.business.feature2": "Współpraca zespołowa",
  "pricing.business.feature3": "Podstawowy+niestandardowy scenariusz",
  "pricing.business.feature4": "Definiuj i używaj szablonów",
  "pricing.business.feature5": "Historia odpowiedzi",
  "pricing.business.feature6": "Zaawansowane dostosowanie",
  "pricing.cta.trial": "Rozpocznij bezpłatny okres próbny",
  "pricing.cta.subscribe": "Subskrybuj",
  "pricing.cta.contact": "Skontaktuj się z działem sprzedaży",
  "pricing.cta.current": "Obecny plan",
  "pricing.currentPlan": "Obecny plan:",
  "pricing.endDate": "Data zakończenia obecnego planu:",
  "pricing.autoRenewalDate": "Data automatycznego odnowienia obecnego planu:",
  "pricing.answersLeft": "Pozostałe odpowiedzi:",
  "pricing.planName.free": "Plan Free",
  "pricing.planName.proMonthly": "Plan Pro-Miesięczny",
  "pricing.planName.proYearly": "Plan Pro-Roczny",
  "pricing.planName.maxMonthly": "Plan Enterprise-Miesięczny",
  "pricing.planName.maxYearly": "Plan Enterprise-Roczny",
  "pricing.autoRenews": "Liczba Twoich odpowiedzi zostanie automatycznie odnowiona:",
  "pricing.needMore": "Potrzebujesz więcej odpowiedzi?",
  "pricing.upgradeBelow": "Ulepsz swój plan poniżej",
  "pricing.doNotRollOver": "Niewykorzystane odpowiedzi nie przechodzą na następny okres",
  "pricing.willCancelOn": "Zostanie anulowane:",
  "pricing.downgradeScheduled": "Zaplanowano obniżkę. Zostanie zmieniony na",
  "pricing.on": "dnia:",
  "pricing.upgradeImmediateTitle": "Plan został ulepszony",
  "pricing.upgradeImmediateDesc": "Twój nowy plan jest teraz aktywny.",
  "pricing.downgradeScheduledTitle": "Zaplanowano obniżkę",
  "pricing.downgradeScheduledDesc": "Twój plan zmieni się przy następnym odnowieniu.",
  "pricing.cancelScheduledTitle": "Zaplanowano anulowanie",
  "pricing.cancelScheduledDesc": "Twój plan zakończy się na koniec okresu.",
  "pricing.cancelResumedTitle": "Anulowanie usunięte",
  "pricing.cancelResumedDesc": "Twoja subskrypcja będzie nadal odnawiana.",
  "pricing.cancelPendingDowngrade": "Anuluj",
  "pricing.pendingDowngradeCanceledTitle": "Anulowano zaplanowaną obniżkę",
  "pricing.pendingDowngradeCanceledDesc": "Twój plan pozostanie bez zmian.",
  "pricing.pendingDowngradeCancelFailedTitle": "Anulowanie nie powiodło się",
  "pricing.pendingDowngradeCancelFailedDesc": "Nie można anulować zaplanowanej obniżki. Spróbuj ponownie.",
  "pricing.cancelPendingDowngradeProcessing": "Przetwarzanie...",
  "pricing.scheduled": "Zaplanowane",
  "pricing.processing": "Przetwarzanie...",
  "pricing.getMoreReplies": "Uzyskaj więcej odpowiedzi",
  "pricing.oneTimeTitle": "Uzyskaj więcej odpowiedzi na swoje konto",
  "pricing.oneTimeAmountLabel": "Kwota (USD)",
  "pricing.repliesUnit": "Odpowiedzi",
  "pricing.oneTimeNotice": "Liczba zakupionych odpowiedzi jest ważna w bieżącym cyklu miesięcznym. Do ich wykorzystania wymagana jest aktywna płatna subskrypcja, a niewykorzystane odpowiedzi nie przechodzą na następny okres.",
  "pricing.cancel": "Anuluj",
  "pricing.proceed": "Kontynuuj",
  "pricing.confirmUpgradeTitle": "Potwierdź ulepszenie",
  "pricing.confirmDowngradeTitle": "Potwierdź obniżkę",
  "pricing.confirmUpgradeDesc": "Zamierzasz ulepszyć swój plan. Zmiana zacznie obowiązywać natychmiast, mogą zostać naliczone proporcjonalne opłaty (lub kredyty).",
  "pricing.confirmDowngradeDesc": "Zamierzasz zaplanować obniżkę. Twoje obecne funkcje pozostaną aktywne do końca bieżącego okresu rozliczeniowego.",
  "pricing.downgradeEffectNote": "Obniżka nie zwraca pieniędzy za bieżący cykl.",
  "pricing.downgradeApplyNextCycle": "Nowy plan zostanie automatycznie uruchomiony przy odnowieniu.",
  "pricing.confirmCancel": "Wróć",
  "pricing.confirmProceedUpgrade": "Ulepsz teraz",
  "pricing.confirmProceedDowngrade": "Zaplanuj obniżkę",

  // FAQ Section
  "faq.title": "Często zadawane pytania",
  "faq.subtitle": "Wszystko, co musisz wiedzieć o communicate2win",
  "faq.q1": "Jakie scenariusze komunikacji są obsługiwane?",
  "faq.a1": "Obsługujemy komunikację w miejscu pracy, relacje osobiste, korespondencję akademicką, obsługę klienta, pozyskiwanie klientów i wiele innych scenariuszy. Nasza sztuczna inteligencja dostosowuje się do kontekstu i tonu wymaganego w każdej sytuacji.",
  "faq.q2": "Jak szybko generowane są odpowiedzi?",
  "faq.a2": "Nasza sztuczna inteligencja generuje odpowiedzi w ciągu kilku sekund. Priorytetem jest szybkość bez kompromisów w jakości, zapewniając natychmiastowe uzyskanie profesjonalnych odpowiedzi.",
  "faq.q3": "Czy mogę anulować subskrypcję w dowolnym momencie?",
  "faq.a3": "Tak, możesz anulować subskrypcję w dowolnym momencie. Nie ma długoterminowych zobowiązań, a plan można obniżyć lub podwyższyć według potrzeb.",
  "faq.q4": "Czy moje dane są bezpieczne i prywatne?",
  "faq.a4": "Tak, wdrażamy kompleksowe środki bezpieczeństwa, w tym szyfrowanie, kontrolę dostępu i regularne audyty bezpieczeństwa. Twoje dane wejściowe i wygenerowane odpowiedzi są przechowywane jako część historii użytkownika, aby umożliwić funkcje takie jak przeglądanie odpowiedzi i tworzenie szablonów. Dane historyczne można usunąć w dowolnym momencie za pomocą ustawień konta.",
  "faq.q5": "Co jeśli skończą mi się Replies?",
  "faq.a5": "Użytkownicy Free muszą poczekać do następnego miesięcznego cyklu na odnowienie limitu. Po aktualizacji do Pro, jeśli zabraknie Replies możesz kupić dodatkowe jednorazowe Replies; dodatkowe są ważne tylko w bieżącym cyklu miesięcznym. Użytkownicy Enterprise mają nielimitowane Replies.",
  "faq.q6": "Jakie języki są obsługiwane?",
  "faq.a6": "Obecnie obsługujemy język angielski, planujemy rozszerzenie na hiszpański, francuski, niemiecki i inne główne języki. Sztuczna inteligencja może skutecznie obsługiwać komunikację wielojęzyczną.",

  // Testimonials Section
  "testimonials.title": "Galeria komunikacji",
  "testimonials.subtitle": "Publiczne wiadomości, e-maile i odpowiedzi udoskonalone przez AI, które mogą Cię zainspirować",
  "testimonials.sarah.name": "Sarah Johnson",
  "testimonials.sarah.title": "Kierownik marketingu",
  "testimonials.sarah.quote": "communicate2win zmienił sposób, w jaki obsługuję komunikację z klientami. Odpowiedzi są profesjonalne i oszczędzają mi godziny tygodniowo.",
  "testimonials.michael.name": "Michael Chen",
  "testimonials.michael.title": "Kierownik sprzedaży",
  "testimonials.michael.quote": "Szablony scenariuszy w miejscu pracy są niezwykle dokładne. Mój wskaźnik odpowiedzi wzrósł o 40% od czasu korzystania z tego narzędzia.",
  "testimonials.emily.name": "Emily Rodriguez",
  "testimonials.emily.title": "Kierownik sukcesu klienta",
  "testimonials.emily.quote": "Idealne do obsługi trudnych sytuacji z klientami. Sztuczna inteligencja doskonale rozumie kontekst i ton.",
  "testimonials.more": "Kliknij galerię, aby przejrzeć pełną wystawę",

  // Interface Elements
  "interface.generating": "Generowanie odpowiedzi...",
  "interface.generate": "Wygeneruj odpowiedź AI",
  "interface.processing": "Przetwarzanie...",
  "interface.advancedOptions": "Opcje zaawansowane",
  "interface.clearInput": "Wyczyść dane wejściowe",
  "interface.clearDescription": "Wyczyść opis",
  // Marquee / Logos
  "marquee.trusted": "Partnerzy / Wsparcie",
  "marquee.aria": "Logo marek",

  // History and Showcase
  "history.shareToShowcase": "Udostępnij w galerii",
  "history.showcased": "W galerii",
  "history.shareConfirm": "Udostępnić ten post w galerii? Tej czynności nie można cofnąć, chyba że usuniesz post.",
  "history.sharedBy": "Udostępnione przez:",
  "interface.copy": "Kopiuj",
  "interface.share": "Udostępnij",
  "interface.shareResponse": "Udostępnij odpowiedź",
  "interface.shareNative": "Udostępnij przez system",
  "interface.shareEmail": "E-mail",
  "interface.copyShareText": "Kopiuj z linkiem",
  "interface.shareTextCopied": "Odpowiedź i link skopiowane do schowka.",
  "interface.ready": "Gotowy do generowania",
  "interface.enterMessage": "Wprowadź treść wiadomości i wybierz scenariusz, aby rozpocząć pracę z odpowiedziami opartymi na AI.",
  "interface.fast": "Szybki",
  "interface.accurate": "Dokładny",
  "interface.professional": "Profesjonalny",
  "interface.translation": "Tłumaczenie",
  "interface.responseDescription": "Oto przemyślana i profesjonalna odpowiedź dopasowana do kontekstu:",
  "interface.multipleOptions": "Wiele opcji odpowiedzi:",
  "interface.option": "Opcja",
  "interface.noContent": "Brak dostępnej treści",

  // Placeholders
  "placeholder.message": "Wklej wiadomość, na którą odpowiadasz, treść e-maila lub tekst, który otrzymałeś...",

  // Dropdowns
  "dropdown.useTemplates": "Użyj szablonów",
  "dropdown.scenario": "Brak scenariusza",
  "dropdown.target": "Brak celu",
  "dropdown.tone": "Brak tonu",

  // Scenario Options
  "scenario.email": "E-mail",
  "scenario.message": "Wiadomość",
  "scenario.workplace": "Miejsce pracy",
  "scenario.school": "Szkoła",
  "scenario.home": "Dom",
  "scenario.business": "Biznes",
  "scenario.academic": "Akademicki",
  "scenario.social": "Społeczny",
  "scenario.formal": "Formalny",
  "scenario.casual": "Nieformalny",
  "scenario.professional": "Profesjonalny",
  "scenario.personal": "Osobisty",
  "scenario.customerService": "Obsługa klienta",
  "scenario.interview": "Rozmowa kwalifikacyjna",
  "scenario.presentation": "Prezentacja",

  // Target Options
  "target.lover": "Partner",
  "target.friend": "Przyjaciel",
  "target.boss": "Szef",
  "target.colleague": "Kolega",
  "target.classmate": "Kolega z klasy",
  "target.parents": "Rodzice",
  "target.child": "Dziecko",
  "target.teacher": "Nauczyciel",
  "target.student": "Student",
  "target.client": "Klient",
  "target.customer": "Klient",
  "target.stranger": "Nieznajomy",
  "target.family": "Rodzina",
  "target.sibling": "Rodzeństwo",
  "target.neighbor": "Sąsiad",
  "target.mentor": "Mentor",
  "target.supplier": "Dostawca",
  "target.serviceProvider": "Dostawca usług",
  "target.partner": "Partner",
  "target.subordinate": "Podwładny",

  // Tone Options
  "tone.humorous": "Humorystyczny",
  "tone.serious": "Poważny",
  "tone.happy": "Szczęśliwy",
  "tone.angry": "Zły",
  "tone.mischievous": "Psotny",
  "tone.polite": "Uprzejmy",
  "tone.casual": "Nieformalny",
  "tone.formal": "Formalny",
  "tone.friendly": "Przyjazny",
  "tone.confident": "Pewny siebie",
  "tone.apologetic": "Przepraszający",
  "tone.enthusiastic": "Entuzjastyczny",

  // Status Messages
  "status.copied": "Skopiowano!",
  "status.copyDescription": "Odpowiedź skopiowana do schowka.",
  "status.copyWithTranslationDescription": "Odpowiedź i tłumaczenie skopiowane do schowka.",
  "status.success": "Odpowiedź wygenerowana pomyślnie.",
  "status.successWithTranslation": "Odpowiedź wygenerowana z tłumaczeniem.",
  "status.successWithoutTranslation": "Odpowiedź wygenerowana pomyślnie.",
  "status.error": "Generowanie nie powiodło się",
  "status.errorDescription": "Nie udało się wygenerować odpowiedzi. Spróbuj ponownie.",
  "status.enterContent": "Wprowadź treść",
  "status.enterContentDescription": "Dodaj wiadomość, na którą chcesz odpowiedzieć.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "Opis (opcjonalny)",
  "restriction.descriptionLabel": "Opis (Tylko dla subskrybentów Pro / Enterprise)",
  "restriction.proMaxOnly": "* Tylko dla subskrybentów Pro / Enterprise",
  "restriction.desPrompt": "Wprowadź kontekst, informacje tła lub konkretne wymagania, które mogą pomóc w generowaniu lepszych odpowiedzi...",

  // Demo functionality for non-logged-in users
  "demo.title": "Wybierz wiadomość do odpowiedzi",
  "demo.option1": "Otwarcie sprzedażowe (zimny kontakt)",
  "demo.option2": "Radzenie sobie z sondą \"wasza cena jest wysoka\"",
  "demo.option3": "Autoprezentacja na rozmowie kwalifikacyjnej (wersja 30-sekundowa)",
  "demo.option4": "Odpowiedź e-mail",
  "demo.option5": "Kontynuacja dla perspektywy \"przeczytane-ale-bez-odpowiedzi\"",
  "demo.option6": "Elevator pitch (30 sekund)",
  "demo.runDemo": "Uruchom Demo",
  "demo.inputContent": "Treść Wejściowa:",
  "demo.scenario": "Scenariusz:",
  "demo.target": "Cel:",
  "demo.tone": "Ton:",
  "demo.description": "Opis:",

  // Showcase Page
  "showcase.title": "Galeria komunikacji",
  "showcase.subtitle": "Odkryj inspirujące komunikacje oparte na AI udostępnione przez naszą społeczność",
  "showcase.userPrefix": "Publiczna komunikacja przez",
  "showcase.backAll": "Powrót do wszystkich wystaw",
  "showcase.sortBy": "Sortuj według:",
  "showcase.sort.newest": "Najpierw najnowsze",
  "showcase.sort.oldest": "Najpierw najstarsze",
  "showcase.sort.scenario": "Według scenariusza",
  "showcase.sort.target": "Według celu",
  "showcase.sort.tone": "Według tonu",
  "showcase.filter.scenario": "Scenariusz:",
  "showcase.filter.target": "Cel:",
  "showcase.filter.tone": "Ton:",
  "showcase.filter.all": "Wszystkie",
  "showcase.loading": "Ładowanie galerii...",
  "showcase.loadingUser": "Ładowanie komunikacji użytkownika...",
  "showcase.loadingMore": "Ładowanie więcej...",
  "showcase.none.userTitle": "Brak jeszcze publicznych komunikacji",
  "showcase.none.globalTitle": "Brak jeszcze elementów w galerii",
  "showcase.none.userDesc": "Ten użytkownik nie udostępnił jeszcze żadnych komunikacji w galerii.",
  "showcase.none.globalDesc": "Bądź pierwszym, który udostępni swoją komunikację AI w galerii!",
  "showcase.messageDetails": "Szczegóły wiadomości",
  "showcase.field.date": "Data",
  "showcase.field.scenario": "Scenariusz",
  "showcase.field.target": "Cel",
  "showcase.field.tone": "Ton",
  "showcase.originalMessage": "Oryginalna wiadomość",
  "showcase.description": "Opis",
  "showcase.aiResponse": "Odpowiedź AI",

  // Templates
  "templates.saveAsTemplate": "Zapisz jako szablon",
  "templates.saved": "Szablon zapisany",
  "templates.saveSuccess": "Szablon został pomyślnie zapisany",
  "templates.title": "Moje szablony",
  "templates.new": "Nowy szablon",
  "templates.loading": "Ładowanie...",
  "templates.none": "Nie znaleziono szablonów",
  "templates.name": "Nazwa",
  "templates.scenario": "Scenariusz",
  "templates.target": "Cel",
  "templates.tone": "Ton",
  "templates.description": "Opis",
  "templates.save": "Zapisz",
  "templates.saving": "Zapisywanie...",
  "templates.delete": "Usuń szablon",
  "templates.deleteConfirm": "Usunąć ten szablon?",
  "templates.deleteFailed": "Nie udało się usunąć szablonu",
  "templates.nameRequired": "* Wprowadź nazwę szablonu",
  "templates.deleteSuccess": "Szablon został pomyślnie usunięty",

  // History Modal additions
  "history.messageDetails": "Szczegóły wiadomości",
  "history.messageDetailsDesc": "Wyświetl i zarządzaj szczegółami wiadomości, w tym oryginalnym wejściem i wygenerowaną odpowiedzią AI.",
  "history.field.date": "Data",
  "history.field.scenario": "Scenariusz",
  "history.field.target": "Cel",
  "history.field.tone": "Ton",
  "history.originalMessage": "Oryginalna wiadomość",
  "history.aiResponse": "Odpowiedź AI",
  "history.description": "Opis",
  "history.listTitle": "Historia wiadomości",
  "history.listDesc": "Przeglądaj, filtruj i zarządzaj historią rozmów. Kliknij dowolną wiadomość, aby wyświetlić szczegóły.",
  "history.sortBy": "Sortuj według:",
  "history.sort.newest": "Najpierw najnowsze",
  "history.sort.oldest": "Najpierw najstarsze",
  "history.sort.scenario": "Według scenariusza",
  "history.sort.target": "Według celu",
  "history.sort.tone": "Według tonu",
  "history.filter.scenario": "Scenariusz:",
  "history.filter.target": "Cel:",
  "history.filter.tone": "Ton:",
  "history.filter.all": "Wszystkie",
  "history.loading": "Ładowanie historii...",
  "history.loadingMore": "Ładowanie więcej...",
  "history.none": "Nie znaleziono wiadomości",
  "history.showing": "Wyświetlanie {current} z {total} wiadomości",
  "history.allLoaded": "Wszystkie wiadomości załadowane",
  "history.scrollMore": "Przewiń w dół, aby załadować więcej",
  "history.loadMoreButton": "Załaduj więcej",
  "history.deleteMessage": "Usuń wiadomość",
  "history.deleting": "Usuwanie...",
  "history.deleteSuccess": "Rekord wiadomości został pomyślnie usunięty",
  "history.deleteFailed": "Nie udało się usunąć rekordu wiadomości, spróbuj ponownie",
  "history.confirmDeleteTitle": "Potwierdź usunięcie",
  "history.confirmDeleteSubtitle": "Tej czynności nie można cofnąć",
  "history.confirmDeleteDesc": "Czy na pewno chcesz usunąć ten rekord wiadomości?",
  "history.confirmDeleteAction": "Potwierdź usunięcie",
  "history.shareTitle": "Udostępnij w galerii",
  "history.shareSubtitle": "Upublicznij tę wiadomość",
  "history.sharing": "Udostępnianie...",
  "history.confirmShareAction": "Potwierdź udostępnienie",
  "history.shareSuccess": "Wiadomość została pomyślnie udostępniona w galerii",
  "history.shareFailed": "Nie udało się udostępnić w galerii, spróbuj ponownie",
  "templates.saveFailed": "Nie udało się zapisać szablonu",

  // User Menu
  "userMenu.myAccount": "Moje Konto",
  "userMenu.history": "Historia",
  "userMenu.templates": "Szablony",
  "userMenu.signOut": "Wyloguj się",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "Podgląd odpowiedzi AI",
  "hero.preview.scenarioLabel": "Scenariusz",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "Otwarcie sprzedaży",
  "demo.shortTitle.priceObjection": "Obiekcja cenowa",
  "demo.shortTitle.interviewIntro": "Wstęp rozmowy kwalifikacyjnej",
  "demo.shortTitle.emailReply": "Odpowiedź e-mail",
  "demo.shortTitle.followUp": "Kontynuacja",
  "demo.shortTitle.elevatorPitch": "Elevator pitch",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "odpowiedź",
  "demoTabs.inputPrompt": "PROMPT WEJŚCIOWY",
  "demoTabs.context": "KONTEKST",
  "demoTabs.description": "Opis",
  "demoTabs.generate": "Generuj",
  "demoTabs.aiOutput": "WYJŚCIE AI",
  "demoTabs.sample": "przykład",
  "demoTabs.streaming": "Strumieniowanie tokenów...",
  "preview.section.scenarioTemplates.title": "Scenariusze i szablony",
  "preview.section.scenarioTemplates.subtitle": "Szybko wybierz scenariusz lub zastosuj zapisany szablon. Szablony wstępnie wypełniają opis/cel/ton, dzięki czemu możesz od razu przejść do generowania wysokiej jakości.",
  "preview.section.customInputs.title": "Niestandardowe dane wejściowe",
  "preview.section.customInputs.subtitle": "Główne dane wejściowe + opcjonalny opis + zaawansowane selektory scenariusza/celu/tonu. Dowolnie łącz elementy, aby uzyskać wyniki kontekstowe.",
  "preview.section.cutReplyTime.title": "Skróć czas odpowiedzi o 90%",
  "preview.section.cutReplyTime.subtitle": "Porównaj ręczne tworzenie wersji roboczych z pomocą AI. Równoległe opcje + wbudowane pętle tłumaczenia lub korekty.",
  "preview.section.copyShare.title": "Kopiowanie i udostępnianie jednym kliknięciem",
  "preview.section.copyShare.subtitle": "Wiele opcji ułożonych z zunifikowanymi górnymi akcjami: kopiuj wszystko / udostępnij / kopiuj dla opcji. Tłumaczenie jest automatycznie dołączane.",
  "preview.templates.my": "Moje szablony",
  "preview.templates.new": "Nowy",
  "preview.manualFlow": "Ręczny przepływ",
  "preview.aiAssisted": "Z pomocą AI",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "Zaplanuj strukturę i ton",
  "preview.manualFlow.step2": "Szkicuj wstęp / usuń i przepisz",
  "preview.manualFlow.step3": "Dostosuj uprzejmość i gramatykę",
  "preview.manualFlow.step4": "Wyszukaj słownictwo + zweryfikuj tłumaczenie",
  "preview.manualFlow.step5": "Wklej do aplikacji docelowej",
  "preview.copyAll": "Kopiuj wszystko",
  "preview.share": "Udostępnij",
  "preview.enPlusTranslation": "EN + Tłumaczenie",
  "preview.translationAppendNote": "(*) Tłumaczenie jest automatycznie dołączane podczas kopiowania wszystkiego.",
  "preview.field.scenario": "Scenariusz",
  "preview.field.target": "Cel",
  "preview.field.tone": "Ton",
  "preview.auto": "Automatyczny",
  "preview.step.pasteOrTemplate": "Wklej żądanie lub wybierz szablon",
  "preview.step.optionalDescription": "(Opcjonalnie) dodaj opis/scenariusz",
  "preview.step.pickOption": "Wybierz jedną z wygenerowanych opcji",
  "preview.step.copyShareTranslate": "Kopiuj/udostępnij/tłumacz jednym kliknięciem",
  "preview.time.manual": "5–8 minut",
  "preview.time.ai": "30–40 sekund"
};